const errorsMapping = {
    SOMETHING_WENT_WRONG: 'errors.somethingWentWrong',
    ORDER_NOT_FOUND: 'checkout.errors.orderNotFound'
};

export { errorsMapping };
//# sourceMappingURL=errors-mapping.js.map
